/**
 * Parser incremental de Server-Sent Events. Chame com cada chunk de texto;
 * eventos completos (terminados por linha em branco) disparam onEvent.
 */
export function parseSseChunks(onEvent: (event: string, data: string) => void) {
  let buffer = "";

  function emit(raw: string) {
    let event = "message";
    const data: string[] = [];
    for (const line of raw.split("\n")) {
      if (line.startsWith("event:")) event = line.slice(6).trim();
      else if (line.startsWith("data:")) data.push(line.slice(5).trimStart());
    }
    if (data.length > 0) onEvent(event, data.join("\n"));
  }

  return (chunk: string, flush = false) => {
    buffer += chunk;
    let separator = buffer.indexOf("\n\n");
    while (separator !== -1) {
      const raw = buffer.slice(0, separator);
      buffer = buffer.slice(separator + 2);
      emit(raw);
      separator = buffer.indexOf("\n\n");
    }
    if (flush && buffer.trim() !== "") {
      emit(buffer);
      buffer = "";
    }
  };
}
